import { render, staticRenderFns } from "./4_event.vue?vue&type=template&id=18143778&scoped=true&"
import script from "./4_event.vue?vue&type=script&lang=js&"
export * from "./4_event.vue?vue&type=script&lang=js&"
import style0 from "./4_event.vue?vue&type=style&index=0&id=18143778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18143778",
  null
  
)

export default component.exports